import { useRef, useState } from "react"

interface Props {
  emailAssetUrl: string
  facebookAssetUrl: string
  giftAssetUrl: string
  linkAssetUrl: string
  referralCodePath: string
  twitterAssetUrl: string
}

const ReferralCode = (props: Props) => {
  const referralCodePathEncoded = encodeURIComponent(props.referralCodePath)
  const referralBodyEncoded = `${encodeURI(
    "Join IFTTT. Get 10% off when you sign up with my link:"
  )} ${referralCodePathEncoded}`
  const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${referralCodePathEncoded}&amp;src=sdkpreparse`
  const twitterShareUrl = `https://twitter.com/intent/tweet?text=${referralBodyEncoded}`
  const emailUrl = `mailto:?subject=Join IFTTT&body=${referralBodyEncoded}`

  const referralCodeInput = useRef()
  const [copied, setCopied] = useState(false)

  const onReferralCodeClick = e => {
    e.target.select()
  }

  const onEmailClick = () => {
    // nothing to do here
  }

  const onTwitterClick = e => {
    e.preventDefault()

    window.open(
      twitterShareUrl,
      "Join IFTTT",
      "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420"
    )
  }

  const onFacebookClick = e => {
    if (window.FB) {
      e.preventDefault()
      window.FB.ui(
        {
          method: "share",
          href: props.referralCodePath,
        },
        () => {}
      )
    }
  }

  const onCopyClick = () => {
    referralCodeInput.current.select()
    navigator.clipboard
      .writeText(props.referralCodePath)
      .then(() => {
        setCopied(true)
        setTimeout(() => setCopied(false), 1500)
      })
      // No feedback on failure; the selected input remains as manual fallback.
      .catch(() => {})
  }

  const renderButtonIcons = (image, url, onClick, title) => {
    const target = url.match(/mailto/) ? "" : "_blank"

    return (
      <a
        href={url}
        target={target}
        className="share-button"
        onClick={onClick}
        title={title}
      >
        <img src={image} alt="" width="48" height="48" />
      </a>
    )
  }

  return (
    <section className="refer_a_friend">
      <h1>Refer a friend</h1>

      <div className="gift-tile">
        <img src={props.giftAssetUrl} alt="" width="70" height="66" />
      </div>

      <p className="body-large">Get 10% off and get a credit when someone subscribes using your link.</p>

      <div className="share">
        <input
          type="text"
          readOnly="readonly"
          className="referral-code"
          value={props.referralCodePath}
          ref={referralCodeInput}
          onClick={onReferralCodeClick}
        />

        <div className="actions">
          {renderButtonIcons(
            props.facebookAssetUrl,
            facebookShareUrl,
            onFacebookClick,
            "Share your code on Facebook"
          )}
          {renderButtonIcons(
            props.emailAssetUrl,
            emailUrl,
            onEmailClick,
            "Share your code via email"
          )}
          {renderButtonIcons(
            props.twitterAssetUrl,
            twitterShareUrl,
            onTwitterClick,
            "Share your code on X"
          )}
          <button
            className="share-button share-link"
            onClick={onCopyClick}
            title="Copy your link"
            aria-label="Copy your link"
          >
            <img src={props.linkAssetUrl} alt="" width="25" height="25" />
          </button>
        </div>

        <span className="copy-feedback body-caption" aria-live="polite">
          {copied ? "Link copied" : ""}
        </span>
      </div>
    </section>
  )
}

export default ReferralCode
